export type Role = 'User' | 'FTP' | 'UDU/Internal_User' | 'UDU/Internal_Admin';
export const Role = {
  User: 'User' as Role,
  Ftp: 'FTP' as Role,
  InternalUser: 'UDU/Internal_User' as Role,
  InternalAdmin: 'UDU/Internal_Admin' as Role,
};
